const te = {
  // Navigation
  BACK: "వెనుకకు",
  NEXT: "తదుపరి",

  // Actions
  SPEAK: "Speak",
  LISTEN: "Listen",
  RETRY: "మళ్లీ ప్రయత్నించండి",
  SUBMIT: "సమర్పించండి",
  START: "Start",
  SKIP: "Skip",

  // Status
  LOADING: "లోడ్ అవుతోంది…",
  LOADING_GAME: "Loading game...",

  // Feedback
  HURRAY: "Hurray!!!",
  ALMOST_THERE: "Almost There!!!",
  GREAT: "అద్భుతంగా చేశారు!",
  DEMO_COMPLETE: "Demo Complete!",

  // Errors
  GAME_ERROR: "Error loading game",
  NO_OPTIONS: "No options available",
  MIC_PERMISSION:
    "We need permission to hear you! Please allow microphone access.",
  CANT_HEAR: "We can't hear you!",

  // Microphone / Audio
  MIC_TEST: "Let's test your microphone!",
  LISTEN_AND_REPEAT: "Hi! Listen to the audio and repeat it!",
  ALL_TESTS_PASSED: "All tests passed! You're ready to start learning!",
  CLICK_LISTEN: "Click to listen",

  // Phone conversation activity
  PHONE_RINGS: "Phone rings...",
  CONVO_DONE: "Conversation Complete!",

  // Practice.jsx — activity headers
  PRACTICE_GUESS_IMAGE: "క్రింద ఉన్న చిత్రాన్ని ఊహించండి",
  PRACTICE_SPEAK_WORD: "క్రింద ఉన్న పదాన్ని పలకండి",
  PRACTICE_SPEAK_BELOW: "క్రింద ఉన్నదాన్ని పలకండి",
  PRACTICE_READ_QUESTION_RECORD_RESPONSE:
    "ప్రశ్నను చదివి మీ సమాధానాన్ని రికార్డ్ చేయండి",
  PRACTICE_READ_QUESTION_SELECT_ANSWER:
    "ప్రశ్నను చదివి సరైన సమాధానాన్ని ఎంచుకోండి",
  PRACTICE_LOOK_PICTURE_SPEAK_ANSWER:
    "చిత్రాన్ని చూసి క్రింద నుండి సరైన సమాధానాన్ని పలకండి",
  PRACTICE_FORM_SENTENCE_SPEAK: "Form a sentence using the words and speak",
  PRACTICE_FILL_IN_THE_BLANK: "Fill in the blank",
  PRACTICE_LETTER_RECOGNITION: "అక్షర గుర్తింపు",
  PRACTICE_MEMORY_CHALLENGE: "జ్ఞాపకశక్తి సవాలు",
  PRACTICE_F3_APPLY_LETTER_SPEED: "వర్తింపజేయండి {step} – అక్షర వేగం",
  PRACTICE_F3_PRACTICE_LETTER_SPEED: "అభ్యాసం చేయండి {step} – అక్షర వేగం",
  PRACTICE_LETTER_LAUNCHER_TITLE: "లెటర్ లాంచర్",
  PRACTICE_LETTER_LAUNCHER_NOT_IMPLEMENTED:
    "లెటర్ లాంచర్ భాగం ఇంకా అమలు కాలేదు",
  PRACTICE_UNABLE_LOAD_CONTENT_RETRY:
    "కంటెంట్ లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి",
  PRACTICE_UNABLE_LOAD_F2_STEP_RETRY:
    "F2 దశ లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి",
  PRACTICE_UNABLE_LOAD_F3_STEP_RETRY:
    "F3 దశ లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి",
  PRACTICE_UNABLE_LOAD_F1_STEP_RETRY:
    "F1 దశ లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి",
  PRACTICE_F3_LETTER_LAUNCHER_STUB_TITLE: "F3 ఫ్లో – లెటర్ లాంచర్",

  // Assesment.jsx — discovery screen, header, dialogs
  ASSESSMENT_TEST_LANGUAGE_SKILLS: "మీ భాషా నైపుణ్యాలను పరీక్షించుకుందాం",
  ASSESSMENT_GOOD_LANGUAGE_SKILLS: "మీకు మంచి భాషా నైపుణ్యాలు ఉన్నాయి",
  ASSESSMENT_TAKE_COMPLETE_LEVEL:
    "స్థాయి {level} పూర్తి చేయడానికి మూల్యాంకనం చేయండి",
  ASSESSMENT_TAKE_DISCOVER_LEVEL:
    "మీ స్థాయిని తెలుసుకోవడానికి మూల్యాంకనం చేయండి",
  ASSESSMENT_START_F1: "F1 ప్రారంభించండి",
  ASSESSMENT_START_F2: "F2 ప్రారంభించండి",
  ASSESSMENT_START_F3: "F3 ప్రారంభించండి",
  ASSESSMENT_LEARN_LETTERS: "అక్షరాలు నేర్చుకోండి",
  ASSESSMENT_START_LEVEL: "స్థాయి {level} ప్రారంభించండి",
  ASSESSMENT_WORDS_LEARNT: "నేర్చుకున్న పదాలు",
  ASSESSMENT_WORDS_PER_MINUTE: "నిమిషానికి పదాలు",
  ASSESSMENT_SELECT_LANGUAGE: "భాషను ఎంచుకోండి",
  ASSESSMENT_LANGUAGE_SHORT: "భాష",
  ASSESSMENT_AUDIO_TEST: "ఆడియో పరీక్ష",
  ASSESSMENT_ALPHABET_CHART: "అక్షరాల చార్ట్",
  ASSESSMENT_LOGOUT: "లాగ్ అవుట్",
  ASSESSMENT_GO_HOME_CHANGE_LANGUAGE:
    "భాష మార్చడానికి హోమ్ స్క్రీన్‌కు వెళ్లండి",
  ASSESSMENT_DIALOG_OOPS: "అయ్యో..",
  ASSESSMENT_DIALOG_CONTINUE: "కొనసాగించండి",
  ASSESSMENT_LANG_CONFIRM: "నిర్ధారించండి",
};

export default te;
